import React from 'react';
import { Ticket, TicketStatus } from 'types/Ticket';
import { getFormattedDateAndTime } from 'utils/helpers';
import WidgetBox from 'components/widgets/WidgetBox';
import Button from 'components/Button/Button';
import styles from './TicketCard.module.css';

interface TicketCardProps {
    ticket: Ticket;
    showModal: (uuid: string) => void;
}

function TicketCard({ ticket, showModal }: TicketCardProps) {
    return (
        <WidgetBox title={`${ticket.plate} - ${ticket.state}`}>
            <div className={styles.cardBody}>
                <b>Status:</b> {ticket.status === TicketStatus.CREATED ? 'Open' : ticket.status}
                <br />
                <b>Violation Number:</b> {ticket.code}
                <br />
                <b>Date Issued:</b> {getFormattedDateAndTime(new Date(Number(ticket.created_at) * 1000))}
                {ticket.image_url && <img className={styles.plateImg} src={ticket.image_url} alt="" />}
                {ticket.status === TicketStatus.CREATED && (
                    <Button
                        color="secondary"
                        className={styles.topMargin}
                        size="sm"
                        onClick={() => showModal(ticket.uuid)}
                    >
                        Waive Violation
                    </Button>
                )}
            </div>
        </WidgetBox>
    );
}

export default TicketCard;
